//Этот файл общий для бэка, фронта и фронта админки. Должен совпадать на бэке, фронте и фронте админки


//Способ получения
export enum ReceivingMethod{
    //самовывоз
    SelfDelivery = "self_delivery",
    //доставка
    Delivery = "delivery"
}
//Способ оплаты
export enum PaymentMethod{
    //оплата при получении
    PaymentOnDelivery = "payment_on_delivery",
    //оплата онлайн
    PaymentOnline = "payment_online",
    //банковский перевод
    BankTransfer = "bank_transfer"
}

//Тип пользователя
//Строковая часть перечисления ApiUserType должна соответствовать перечислению в базе данных user_type
export enum ApiUserType{
    //ФИЗЛИЦО
    physical_person = "physical_person",
    
    //ИП
    individual_entrepreneur = "individual_entrepreneur",

    //ЮРЛИЦО
    organization = "organization"
}


/****** WebSocket *******/

//WebSocket события
export enum WebSocketEvent{
    //Установить анонимный id от сервера для клиента
    //Один пользователь может открыть несколько вкладок браузера. Этот id будет уникальным в каждой вкладке
    set_anonymous_id = "set_anonymous_id",

    //Инициализация данных от клиента к серверу (передается тип соединения WebSocketClientType)
    socket_init = "socket_init",

    //Установить user_id (через session_token) от клиента для сервера (когда залогинится юзер или смена на другого юзера)
    login = "login",

    //Сообщение чата от клиента к продавцу
    message_client_to_vendor = "message_client_to_vendor",
    //Сообщение чата от клиента к продавцу от сервера
    message_client_to_vendor_from_server = "message_client_to_vendor_from_server",

    //Сообщение чата от продавца к клиенту
    message_vendor_to_client = "message_vendor_to_client",
    //Сообщение чата от продавца к клиенту от сервера
    message_vendor_to_client_from_server = "message_vendor_to_client_from_server",

    //Список продавцов из истории переписки для клиента с кол-вом непрочитанных сообщений
    vendors_list_of_history = "vendors_list_of_history",
    //Список клиентов из истории переписки для продавца с кол-вом непрочитанных сообщений
    clients_list_of_history = "clients_list_of_history",

    //Запрос на получение переписки для продавца
    get_vendors_history_messages = "get_vendors_history_messages",
    //Запрос на получение переписки для клиента
    get_clients_history_messages = "get_clients_history_messages",

    //Получение переписки для продавца
    vendors_history_messages = "vendors_history_messages",
    //Получение переписки для клиента
    clients_history_messages = "clients_history_messages",

    //Пометка продавца, что сообщение прочитано
    vendor_mark_as_read = "vendor_mark_as_read",
    //Пометка клиента, что сообщение прочитано
    client_mark_as_read = "client_mark_as_read",

    //Пометка продавца для клиента, что сообщение прочитано. От сервера
    vendor_mark_as_read_from_server = "vendor_mark_as_read_from_server",
    //Пометка клиента для продавца, что сообщение прочитано. От сервера
    client_mark_as_read_from_server = "client_mark_as_read_from_server"
}


//Структура данных при передачи между сообщениями
export interface WebSocketDataI{
    //Событие
    event: WebSocketEvent,
    //Данные события. Обычно сериализованные JSON
    data: any
}

//Тип подключенного клиента
export enum WebSocketClientType{
    dazel_ru = "dazel_ru",
    admin_dazel_ru = "admin_dazel_ru"
}